import { useState } from "react";
import { useHistory } from "react-router-dom";
import emailjs from 'emailjs-com';

const Contact = () => {
	const [subject, setSubject] = useState('')
	const [contactEmail, setContactEmail] = useState('')
	const [name, setName] = useState('')
	const [message, setMessage] = useState('')

	const history = useHistory();

	const [isFormVisible, setFormVisibility] = useState(true)

	function sendEmail(e){
		e.preventDefault();
		emailjs.sendForm(
			'service_6l04ugg', 
			'template_6hsm44r', 
			e.target, 
			'user_NmTlAO0rc6XXpbJKLbLAv'
		).then(res=>{
			console.log(res);
		}).catch(err=>console.log(err));
		setContactEmail('');
		setName('');
		setSubject('');
		setMessage('I\'ve received your message and will get back to you as soon as I can!');

		// history.push('/')
		setFormVisibility(false);
	}

	return (
		<div className="contact">
			<h2 className="contact_heading">If you would like to discuss 
			possible work/collaboration opportunities, 
			ideas or feedback, please get in touch!</h2>
			
			<form onSubmit={sendEmail}>
			<label>Name</label>
				<input 
					type="text"
					name="sender_name"
					required
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>
				<label>Email Address</label>
				<input 
					type="text"
					name="sender_email"
					required
					value={contactEmail}
					onChange={(e) => setContactEmail(e.target.value)}
				/>
								<label>Subject</label>
				<input 
					type="text"
					name="message_subject"
					required
					value={subject}
					onChange={(e) => setSubject(e.target.value)}
				/>
				<label>Message</label>
				<textarea 
					name="message_content"
					required
					value={message}
					onChange={(e) => setMessage(e.target.value)}
				></textarea>
				<input 
					type="submit"
					value="Send"
					className="button" 
				/>
			</form>
		</div>
	);
}

export default Contact;